
export function fetchTestDevices(state, { page, sort, filter }) {
  return {
    ...state,
    testDevices: {
      ...state.testDevices,
      currentPage: page,
      sort: sort || state.testDevices.sort,
      filter: filter || state.testDevices.filter,
    },
  };
}

export function fetchTestDevicesSuccess(state, { testDevices }) {
  return {
    ...state,
    testDevices: {
      ...state.testDevices,
      numberOfPages: testDevices.numberOfPages,
      count: testDevices.count,
      items: testDevices.items,
    },
  };
}

export function addTestDevice(state) {
  return {
    ...state,
    editTestDevice: {
      ...state.editTestDevice,
      isFetching: true,
    },
  };
}

export function addTestDeviceSuccess(state, testDevice) {
  return {
    ...state,
    testDevices: {
      ...state.testDevices,
      items: [
        testDevice,
        ...state.testDevices.items,
      ],
    },
    editTestDevice: {
      formName: state.editTestDevice.formName,
      isFetching: false,
      showModal: false,
    },
  };
}

export function addTestDeviceFail(state) {
  return {
    ...state,
    editTestDevice: {
      ...state.editTestDevice,
      isFetching: false,
    },
  };
}

export function updateTestDevice(state) {
  return {
    ...state,
    editTestDevice: {
      ...state.editTestDevice,
      isFetching: true,
    },
  };
}

export function updateTestDeviceSuccess(state, { testDeviceId, testDevice }) {
  let testDevices = state.testDevices;
  if (state.testDevices.items.length > 0) {
    const testDeviceIndex = state.testDevices.items.findIndex(x => x._id === testDeviceId);
    testDevices = {
      ...state.testDevices,
      items: [
        ...state.testDevices.items.slice(0, testDeviceIndex),
        {
          _id: testDeviceId,
          ...testDevice,
        },
        ...state.testDevices.items.slice(testDeviceIndex + 1),
      ],
    };
  }
  return {
    ...state,
    testDevices,
    editTestDevice: {
      isFetching: false,
      showModal: false,
      error: null,
      isFetchingSuccess: true,
    },
  };
}

export function updateTestDeviceFail(state) {
  return {
    ...state,
    editTestDevice: {
      ...state.editTestDevice,
      isFetching: false,
    },
  };
}

export function deleteTestDeviceSuccess(state, { testDeviceId }) {
  const testDeviceIndex = state.testDevices.items.findIndex(x => x._id === testDeviceId);
  const items = [
    ...state.testDevices.items.slice(0, testDeviceIndex),
    ...state.testDevices.items.slice(testDeviceIndex + 1),
  ];
  return {
    ...state,
    testDevices: {
      ...state.testDevices,
      items,
    },
  };
}

export function openEditTestDevice(state, { testDevice }) {
  return {
    ...state,
    editTestDevice: {
      formName: state.editTestDevice.formName,
      showModal: true,
      isFetching: false,
      error: null,
      isFetchingSuccess: true,
      testDevice,
    },
  };
}

export function closeEditTestDevice(state) {
  return {
    ...state,
    editTestDevice: {
      showModal: false,
      isFetching: false,
      error: null,
      isFetchingSuccess: true,
    },
  };
}

export function openTestModeMessage(state) {
  const showModal = localStorage.getItem('shouldMessageBeOpened') !== 'false';

  return {
    ...state,
    testModeMessage: {
      showModal,
    },
  };
}

export function closeTestModeMessage(state) {
  return {
    ...state,
    testModeMessage: {
      showModal: false,
    },
  };
}



/** WEBPACK FOOTER **
 ** ./js/core/testDevices.js
 **/